<template>
    <div>
        <rkm-data-table
            :fields="fields.datatables.reabertura"
            :filter="localFilter"
            :repository="repositories.reaberturaAtendimento"
            :search-by="localSearchOption"
            :reset-table="resetTable"
            :search-table="searchTable"
            ref="RkmDataTable"
            sort-by="data"
            sort-desc
        >
            <template v-slot:filters>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidade"
                            disabled
                            label="Unidade"
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestrutura"
                            disabled
                            label="Local de atendimento"
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="localFieldFilter"
                            @keyup.native.enter="handleEnterKey"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-form-select
                                    :options="searchOptions"
                                    class="m-0"
                                    v-model="localSearchOption"
                                />
                            </rkm-input-group-prepend>

                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="search"
                                    color="primary"
                                    class="btn-search"
                                >
                                    Buscar
                                </rkm-button>
                                <rkm-button
                                    :disabled="!localFieldFilter"
                                    @click="clear"
                                    class="btn-clear"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(pacienteNome)="row">
                <rkm-button
                    class="mr-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Dados cadastrais',
                        html:true,
                        content:
                            '<b>Prontuário:</b> ' + row.item.prontuario + '<br/>' +
                            '<b>Data de Nascimento:</b> ' + row.item.dataNascimento + '<br/>' +
                            '<b>Nome da Mãe:</b> ' + row.item.nomeMae + '<br/>'
                    }"
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                <span v-if="!row.item.sequencialDesconhecido">
                    {{ row.item.pacienteNome }}
                </span>

                <span
                    v-else
                    class="text-primary"
                    v-rkm-popover.hover.top="{
                        title:'Características físicas',
                        content: row.item.caracteristicasFisicas
                    }">
                    {{ row.item.pacienteNome }}
                </span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click="save(row.item)"
                    authorize="update-pronto-atendimento-reabertura-atendimento"
                    color="primary"
                    id="show-btn"
                    small
                    title="Reabrir Atendimento"
                >
                    <rkm-icon icon="upload" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalSetor
            :centros-custo="form.centrosCustoEncaminhamento"
            ref="ModalSetor"
        />
    </div>
</template>

<script>
// Components.
import ModalSetor from './components/setor/Modal'

 // Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { ModalSetor },
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            return {
                datatables: {
                    reabertura: [
                        {
                            key: 'data',
                            label: 'Data',
                            name: 'data',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'faaNumero',
                            label: 'FAA',
                            name: 'prontoAtendimentoFaa.numero',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'sexo',
                            label: 'Sexo',
                            name: 'cadastroSexo.descricao',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'pacienteNome',
                            label: 'Paciente',
                            name: 'cadastroCidadao.nome',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            class: 'col-min text-center',
                            key: 'actions',
                            label: 'Ações',
                        },
                    ],
                },
            }
        },
        searchOptions() {
            return this.fields.datatables.reabertura.filter(field => !!field.searchable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
    },
    created() {
        this.repositories = {
            reaberturaAtendimento: this.getConectaSusRepository('prontoAtendimento.reaberturaAtendimento')
        }
    },
    data: () => ({
        localFieldFilter: null,
        localFilter: null,
        localSearchOption: 'pacienteNome',
        resetTable: false,
        searchTable: false,
        form: {
            unidade: [],
            infraestrutura: [],
            centrosCustoEncaminhamento: [],
        },
        model: {
            unidadeId: null,
            infraestruturaId: null,
            filter: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.form.unidade =  [{
                id: this.lotacao.infraestrutura.unidade.id,
                nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
            }]

            this.form.infraestrutura = [{
                id: this.lotacao.infraestrutura.id,
                nome: this.lotacao.infraestrutura.nome,
            }]

            this.model.unidadeId = this.lotacao.infraestrutura.unidade.id
            this.model.infraestruturaId = this.lotacao.infraestrutura.id

            this.setLoading()

            this.repositories.reaberturaAtendimento.create()
                .then(({ data }) => {

                    this.form.centrosCustoEncaminhamento = data.form.centrosCustoEncaminhamento
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save(item) {
            const reaberturaAtendimento = (centroCustoId) =>
                this.repositories.reaberturaAtendimento.update(item.faaId, { centro_custo_id: centroCustoId })
                    .then(() => {
                        this.showSaveNotification()
                        this.$refs.RkmDataTable.refresh()
                    })
                    .catch(this.handleError)

            this.showConfirmation(`Deseja realmente reabrir o atendimento do(a) paciente ${item.pacienteNome}?`,
                async () => {

                    this.$nextTick().then(() => {

                        this.showConfirmation(`Será possível encontrar o atendimento na funcionalidade
                            Fechamento de FAA. Deseja encaminhar para algum setor?`,
                            async () => {

                                this.$refs.ModalSetor.open(reaberturaAtendimento)
                            },
                            reaberturaAtendimento,
                            this.handleError
                        )
                    })
                }
            )
        },
        search() {
            this.searchTable = true
            this.resetTable = false
            this.localFilter = this.localFieldFilter
            this.$refs.RkmDataTable.refresh();
        },
        clear() {
            this.localSearchOption = 'pacienteNome';
            this.clearSearchOption()
        },
        clearSearchOption() {
            this.localFieldFilter = null
            this.clearTable()
        },
        clearTable() {
            this.localFilter = null
            this.resetTable = true
            this.searchTable = false
        },
        handleEnterKey(event) {

            if (event.key === 'Enter') {
                this.search();
            }
        },
    },
    mixins: [ error, repository ],
    mounted() {

        if (this.searchOptions.length > 0) {
            this.localSearchOption = 'pacienteNome';
        }

        this.load()
    },
    watch: {
        filter(value) {
            this.localFilter = value
        },
        'localSearchOption': function () {

            this.clearSearchOption()
        },
        'localFieldFilter': function () {

            this.clearTable()
        },
    },
}
</script>

<style scoped>
.btn-search {
    border-top-right-radius: 0.25rem!important;
    border-bottom-right-radius: 0.25rem!important;
}
.btn-clear {
    border-top-left-radius: 0.25rem!important;
    border-bottom-left-radius: 0.25rem!important;
}
</style>